export const modulesKeys = {
    modules: (search?: string) => ['permissions', search],
    module: (id: string) => ['permission', id],
};